import LegalPageLayout from "../components/LegalPageLayout";

const highlights = [
  "We collect only the information needed to respond to enquiries, manage business relationships and improve site performance.",
  "We do not sell personal data and we limit access to contact information to authorised team members and service providers.",
  "You can request access, correction or deletion of your personal information by contacting our team.",
];

const sections = [
  {
    heading: "Information We Collect",
    paragraphs: [
      "When you submit a contact form, request a quote or communicate with us directly, we may collect your name, company name, email address, phone number, country and the details of your enquiry. We may also collect technical information such as browser type, device information and usage data through standard analytics and server logs.",
      "This information helps us understand how visitors use the site, keep the platform secure and respond to commercial enquiries efficiently.",
    ],
  },
  {
    heading: "How We Use Your Information",
    paragraphs: [
      "We use personal information to respond to enquiries, prepare quotations, provide requested services, verify business communications and maintain our internal records. Where appropriate, we may also use site analytics to improve performance, usability and content relevance.",
      "We process information only where there is a legitimate business reason to do so, where it is necessary to fulfil your request, or where applicable law requires us to retain certain records.",
    ],
  },
  {
    heading: "Sharing And Storage",
    paragraphs: [
      "We may share information with trusted service providers who support website hosting, security, communication tools and internal business operations. These providers may access information only as needed to perform services on our behalf and are expected to protect it appropriately.",
      "We retain information only for as long as needed for operational, legal or compliance purposes. We take reasonable technical and organisational measures to safeguard the information we store, although no online transmission or storage system can be guaranteed to be completely secure.",
    ],
  },
  {
    heading: "Your Rights",
    paragraphs: [
      "Subject to applicable law, you may request access to the personal data we hold about you, ask us to correct inaccurate information, or request deletion where retention is no longer required. You may also object to certain processing activities or request restrictions in appropriate circumstances.",
      "To make any privacy-related request, please contact us through the details listed on our Contact page and include enough information for us to verify your request.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      eyebrow="PRIVACY POLICY"
      title={<>How Vissera handles your <span className="text-[#B8860B]">personal information</span></>}
      intro="This policy explains what information we collect through our website and business communications, how we use it and the choices available to you."
      lastUpdated="June 14, 2026"
      highlights={highlights}
      sections={sections}
    />
  );
}
